import { buildClient } from '@datocms/cma-client-browser';

const datoCmsClient = buildClient({
  apiToken: import.meta.env.VITE_DATOCMS_API_TOKEN
});

export default datoCmsClient;
